import { render, staticRenderFns } from "./ModalNotificationBody.vue?vue&type=template&id=8330c60c&scoped=true"
import script from "./ModalNotificationBody.vue?vue&type=script&lang=js"
export * from "./ModalNotificationBody.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificationBody.vue?vue&type=style&index=0&id=8330c60c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8330c60c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8330c60c')) {
      api.createRecord('8330c60c', component.options)
    } else {
      api.reload('8330c60c', component.options)
    }
    module.hot.accept("./ModalNotificationBody.vue?vue&type=template&id=8330c60c&scoped=true", function () {
      api.rerender('8330c60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalNotificationBody.vue"
export default component.exports